export default {
  data: {},
  year: '2020',
  sepData: {},
};
